export default __webpack_public_path__ + "gamification-loading.a6dd1521.gif";